import React, { useState } from "react";
import { Typewriter } from "react-simple-typewriter";

function shuffle(array) {
  console.log("pre shuffle: ", array);
  let currentIndex = array.length,
    randomIndex;

  while (currentIndex > 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
  console.log("post shuffle: ", array);
  return array;
}

const ImagesComponent = ({ imagesList, captionsList }) => {
  const [indices, setIndices] = useState(
    shuffle([...Array(imagesList.length).keys()])
  ); // shuffled list of the indices of images/captions
  const [indicesIndex, setIndicesIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(
    indices[indicesIndex]
  );
  let deleteCount = 0;

  const handleSwitch = () => {
    let nextIndex = indicesIndex + 1;
    if (nextIndex >= indices.length) {
      setIndices(shuffle(indices));
      nextIndex = nextIndex % indices.length;
    }
    setIndicesIndex(nextIndex);
    setCurrentImageIndex(indices[nextIndex]);
  };

  const handleDelete = () => {
    deleteCount++;
    if (deleteCount === captionsList[currentImageIndex].length) {
      handleSwitch();
    }
  };

  return (
    <div className="main-wrapper">
      <img
        src={imagesList[currentImageIndex].src}
        alt={imagesList[currentImageIndex].alt}
      />
      <div> </div>
      <p>
        <Typewriter
          words={[captionsList[currentImageIndex]]}
          loop={Infinity} // keep looping forever!
          cursor
          typeSpeed={70}
          deleteSpeed={40}
          delaySpeed={1800}
          onDelete={handleDelete} // check if done deleting
        />
      </p>
    </div>
  );
};

export default ImagesComponent;
